<template>
	<div v-if="code !== null">
		Идёт сохранение...
	</div>
	<div v-else>
		Отсутствует параметр code
	</div>
</template>

<script>
import { authorize } from '@/auth';

export default {
	data() {
		return {
			code: ''
		}
	},
	created() {
		this.code = new URLSearchParams(window.location.search).get("code");
		if (this.code) {
            authorize(this.code, '/');
        } 
	}
}
</script>